import React from 'react'
import { useHistory } from 'react-router-dom'
import BackPageHeader from '../../../components/ui/header/BackPageHeader'
import { Section } from '../../../styled/sections'
import { Title, Text2, Text1Bold, SubTitle } from '../../../components/ui/text'
import { ArrowRight } from '../../../assets/icons'
import theme from '../../../styled/theme'
import { IMAGING_STUDIES } from '../../../constants/imagingStudies'
import ContactHelpCard from '../../../components/ui/contactHelpCard'
import { Card, CardText, Grid, Header } from './styled'

const News = () => {
	const history = useHistory()

	return (
		<Section>
			<BackPageHeader onBack={() => history.goBack()} title="" showBack />
			<Header>
				<Title size="24px" mobileSize="20px" color={theme.colors.text.primaryText}>
					Conocé los estudios por imagen sin turno de nuestras clínicas y centros médicos{' '}
				</Title>
				<Text2
					size="16px"
					mobileSize="14px"
					fontWeight={400}
					color={theme.colors.text.secondaryText}
				>
					Podés acercarte a nuestros centros para realizarte los siguientes estudios, sin turno
					previo:
				</Text2>
			</Header>
			<Grid>
				{IMAGING_STUDIES.map(study => (
					<Card
						key={study.slug}
						onClick={() => history.push(`/inicio/novedades/${study.slug}`)}
					>
						<CardText>
							<Text1Bold size="16px" color={theme.colors.text.primaryText}>
								{study.title}
							</Text1Bold>
							{study.description && (
								<SubTitle size="14px" color={theme.colors.text.secondaryText}>
									{study.description}
								</SubTitle>
							)}
						</CardText>
						<ArrowRight size={40} />
					</Card>
				))}
			</Grid>
			<ContactHelpCard
				title="¿No encontrás el estudio que buscás?"
				description={
					'Comunicate al 0800-666-6587 o por WhatsApp al 11 4493-2017\n(lunes a viernes de 8 a 20 hs) y te ayudamos a sacar el turno.'
				}
			/>
		</Section>
	)
}

export default News
